





















































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import AppConsts from "@/lib/appconst";
import PageRequest from "@/store/entities/page-request";
import TransferOrderDetail from "../../../store/entities/transfer-orders/transfer-order-line";
import TransferOrder from "../../../store/entities/transfer-orders/transfer-order";
import Barcode from "../../components/bar-code.vue";
import { mixins } from "vue-class-component";
import columns from "./view-transfer-order-line-columns";
import InboundException from "../../components/inbound-exception.vue";
import PoExceptions from "@/store/entities/inbound-exceptions/po-exceptions";
import DateTimeMixin from "@/components/mixin/date-time-mixin";
import NoteModal from "../../components/note-modal.vue";
import _ from "lodash";
import moment from "vue-moment";
Vue.use(require("vue-moment"));
class PageTransferOrderLineRequest extends PageRequest {}
@Component({
  components: {
    "bar-code": Barcode,
    "inbound-exception": InboundException,
    "note-modal": NoteModal,
  },
})
export default class ViewTransferOrder extends mixins(DateTimeMixin, AbpBase) {
  @Prop({ type: Boolean, default: false }) value: boolean;
  pagerequest: PageTransferOrderLineRequest =
    new PageTransferOrderLineRequest();
  transferOrder: TransferOrder = new TransferOrder();
  transferOrderLines: Array<TransferOrderDetail> =
    new Array<TransferOrderDetail>();
  transferOrderLinesPerPage: Array<TransferOrderDetail> =
    new Array<TransferOrderDetail>();
  poExceptions: PoExceptions = new PoExceptions();
  spinShow: boolean = false;
  code: string = "";
  id: number = 0;
  refTypeCode: string = AppConsts.refType.TransferOrder;
  cancelNote: string = "";
  noteModalShow: boolean = false;
  sumOrderQty: number = 0;
  sumReceivedQty: number = 0;
  sumPickedQty: number = 0;
  sumPackedQty: number = 0;
  isClient() {
    return this.$store.state.session.client != null;
  }

  get client() {
    return this.$store.state.session.client;
  }
  cancel() {
    this.$store.state.transferOrder.viewTransferOrder = new TransferOrder();
    this.$emit("input", false);
    this.$root.$router.push({ name: "transferorder" });
  }
  canCancelTOReq() {
    if (
      this.transferOrder.outStatusCode !== AppConsts.soStatus.canceled &&
      this.transferOrder.outStatusCode !== AppConsts.sorStatus.canceled &&
      this.transferOrder.outStatusCode !== AppConsts.sorStatus.finished &&
      this.transferOrder.inStatusCode == AppConsts.poStatus.new &&
      this.hasPermission(AppConsts.permissionNames.cancelTOReq)
    ) {
      return true;
    }
    return false;
  }
  openCancelNoteModal() {
    this.cancelNote = "";
    this.noteModalShow = true;
  }
  cancelTOrderReq() {
    if (Util.isEmpty(this.cancelNote)) {
      return;
    }
    this.$Modal.confirm({
      title: this.L("Tips"),
      content: this.L("Confirm.CancelTransferOrderReq"),
      okText: this.L("Yes"),
      cancelText: this.L("No"),
      onOk: async () => {
        this.spinShow = true;
        try {
          await this.$store
            .dispatch({
              type: "transferOrder/cancel",
              data: {
                code: this.transferOrder.toReqCode,
                note: this.cancelNote,
              },
            })
            .then(async (result) => {
              await this.getTransferOrderReq();
              Util.showSuccessMsg(this, "Success.CancelTransferOrderReq");
              this.cancelNote = "";
            });
          this.spinShow = false;
        } catch (error) {
          this.spinShow = false;
        }
      },
    });
  }
  // sale order line
  get list() {
    var re = this.transferOrderLinesPerPage;
    var startIndex = (this.currentPage - 1) * this.pageSize;
    var index = 0;
    re.forEach(function (item) {
      item.orderNo = startIndex + index + 1;
      index++;
    });
    return re;
  }
  get loading() {
    return this.$store.state.transferOrder.loading;
  }
  pageChange(page: number) {
    this.$store.commit("transferOrder/setCurrentPage", page);
    this.getpage();
  }

  pagesizeChange(pagesize: number) {
    this.$store.commit("transferOrder/setPageSize", pagesize);
    this.getpage();
  }

  getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    //filters
    this.pageViewTransferOrderChange();
  }
  pageViewTransferOrderChange() {
    this.transferOrderLinesPerPage = Util.pagingItems(
      this.transferOrderLines,
      this.pageSize,
      this.currentPage
    );
  }
  get pageSize() {
    return this.$store.state.transferOrder.pageSize;
  }

  get totalCount() {
    return this.transferOrderLines.length;
  }

  get currentPage() {
    return this.$store.state.transferOrder.currentPage;
  }
  onReceipt() {
    var url = `/#/transferorder-receipt/${this.transferOrder.id}`;
    window.open(url, "_blank");
  }
  async getPOExceptions() {
    if (!Util.isNull(this.transferOrder.id) && this.transferOrder.id > 0) {
      await this.$store.dispatch({
        type: "inboundException/getAll",
        data: {
          refId: this.id,
          refTypeCode: this.refTypeCode,
        },
      });
      this.poExceptions.items = this.$store.state.inboundException.list;
    }
  }
  async getTransferOrderReq() {
    await this.$store
      .dispatch({
        type: "transferOrder/get",
        data: { id: this.id },
      })
      .then(async (result) => {
        this.transferOrder = result;
        this.transferOrderLines = result.lineResult.items;
        this.id = this.transferOrder.id;
        this.code = this.transferOrder.toReqCode;
        this.getSumQty();
        this.getpage();
        await this.getPOExceptions();
      });
  }
  getSumQty() {
    if (this.transferOrderLines.length > 0) {
      this.sumOrderQty = _.sumBy(this.transferOrderLines, "orderQty");
      this.sumReceivedQty = _.sumBy(this.transferOrderLines, "inReceivedQty");
      this.sumPickedQty = _.sumBy(this.transferOrderLines, "outPickedQty");
      this.sumPackedQty = _.sumBy(this.transferOrderLines, "outPackedQty");
    }
  }
  async created() {
    this.spinShow = true;
    this.id = +this.$root.$router.currentRoute.params.id;
    await this.getTransferOrderReq();
    this.spinShow = false;
  }
  columns = columns;
}
